<!-- @format -->

@if (!!medias.length) {
	<div
		class="hmf-display-flex hmf-flex-column"
		[ngClass]="{ 'hmf-mt-m': !hideTitle() }">
		@if (!hideTitle()) {
			<p class="hmf-body-bold-l">Images</p>
		}
		<div class="hmf-display-flex hmf-align-items-center horizontal-scroll-container">
			@if (medias.length > 0) {
				<product-reviews-review-slider
					class="slider-content"
					[selector]="selector()">
					<ul
						class="carousel-content hmf-display-flex hmf-p-0 hmf-m-0 hmf-pb-xxxs"
						carouselContent>
						@for (
							media of medias;
							track trackByFn($index, media);
							let imageId = $index
						) {
							<li
								class="hmf-display-flex hmf-align-items-center hmf-justify-content-center">
								<product-reviews-review-media
									[media]="media"
									[imageId]="imageId"
									[mediaSource]="mediaSource()"
									(selectedMedia)="
										handleReview($event)
									"></product-reviews-review-media>
							</li>
						}
					</ul>
				</product-reviews-review-slider>
			}
		</div>
	</div>

	<product-reviews-modal></product-reviews-modal>
}
